import { Swiper, SwiperSlide } from "swiper/react"
import DetailsAboutSlide from "./main/details-slider/DetailsAboutSlide"
import MainAboutCard from "./main/MainAboutCard"

const CardSliderSwiper = ({swiperRef, setSelectedChapter, aboutCompany, items}) => {
    return (
        <Swiper
            className={`card-slider product__slider`}
            slidesPerView={1}
            spaceBetween={46}
            onSlideChange={() => setSelectedChapter(swiperRef.current?.activeIndex)}
            onBeforeInit={swiper => {
                swiperRef.current = swiper
            }}
        >
            {aboutCompany && (
                <SwiperSlide>
                    <DetailsAboutSlide selectedSlide={swiperRef.current?.activeIndex} />
                </SwiperSlide>
            )}
            {items.map((item, i) => (
                <SwiperSlide key={i}>
                    <MainAboutCard item={item} />
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default CardSliderSwiper
